import * as http from "@/utils/request";
import {jsonToFormData} from "@/utils";



//列表查询  POST /afterSalesManagement/findList
export  const findList =(page,params)=>{
  
  return http.postJSON("/afterSalesManagement/findList?"+jsonToFormData(page),params);
}


//新增类型 POST /afterSalesManagement/insert
export function insert(params) {
  return http.postJSON("/afterSalesManagement/insert",params);
}

//编辑 POST /afterSalesManagement/update
export function update(params) {
  return http.postJSON("/afterSalesManagement/update",params);
}

//删除 POST /afterSalesManagement/delete
export function deletes(params) {
  return http.postJSON("/afterSalesManagement/delete?"+jsonToFormData(params),{});
}

//异常现象分类列表 POST /afterSalesManagement/dropList
export function dropList(params) {
  return http.postJSON("/afterSalesManagement/dropList?"+jsonToFormData(params),{});
}

//操作日志 POST /afterSalesManagement/findLogList
export function findLogList(page) {
  return http.postJSON("/afterSalesManagement/findLogList?"+jsonToFormData(page),{});
}


//全局共用操作日志 GET /logRecord/findLogRecordPage
export function findLogRecordPage(params){
  return http.get('/logRecord/findLogRecordPage',params)
}








// WEBPACK FOOTER //
// ./src/services/saleclassification.js